/** Describe only the service state we know; a missing log is not startup evidence. */
export function progressText(job: { status: string; phase?: string; log?: string }) {
  if (job.log) return job.log
  if (job.status === 'capacity_wait') return 'Waiting for Codex account capacity.'
  if (job.status === 'queued') return 'Queued for a worker. Previous progress is preserved.'
  if (job.status === 'pending_delivery') return 'Request pending delivery.'
  if (job.status === 'running') return job.phase === 'account_admission'
    ? 'Checking Codex account capacity.' : 'Agent is working. Open activity for the latest progress.'
  return 'Open activity for the latest progress.'
}
